import { IconX } from '@tabler/icons-react'
import { get } from 'react-hook-form'

import { type Account, AccountInclusionStatus, type Connection } from '@subaio/api-types/financedata'
import { Form } from '@subaio/components/src/HookForm'
import { Checkbox } from '@subaio/webapp'

import { ProductLogo } from 'components/ProductLogo'
import { useSnackbar } from 'components/Snackbars'

import { ButtonDelete } from './ButtonDelete'
import { FormWrapper } from './FormWrapper'
import { Header } from './Header'
import { LogoWrapper } from './LogoWrapper'
import { TitleRow } from './TitleRow'
import { Wrapper } from './Wrapper'

type Props = {
	connection: Connection & { accounts: Array<Account> }

	selectedAccountIds: Array<string>
	updateAccountInclusion: (accountsMap: Record<string, boolean>) => Promise<void>
	removeConnection: (connectionId: string) => Promise<void>
}

export const Bank = ({ connection, selectedAccountIds, updateAccountInclusion, removeConnection }: Props) => {
	const { showSnackbar } = useSnackbar()

	return (
		<Wrapper>
			<Header>
				<TitleRow>
					<LogoWrapper>
						<ProductLogo title={connection.providerName} imageUrl={connection.providerLogo} />
					</LogoWrapper>
					{connection.providerName}
				</TitleRow>
				<ButtonDelete
					icon={<IconX />}
					onClick={async () => {
						await removeConnection(connection.id)
						showSnackbar({ message: 'Removed bank connection from your account' })
					}}
				/>
			</Header>
			<FormWrapper>
				<Form<Record<string, boolean>>
					initialValues={Object.fromEntries(
						connection.accounts.map((account) => [
							account.id,
							account.inclusionStatus === AccountInclusionStatus.IncludedByUser,
						]),
					)}
					render={() =>
						connection.accounts.map((account) => (
							<Checkbox
								name={account.id}
								hint={account.bban}
								label={account.name}
								isDisabled={selectedAccountIds.length === 1 && selectedAccountIds[0] === account.id}
							/>
						))
					}
					onSubmit={() => undefined}
					onChange={(fields) => {
						if (fields) {
							updateAccountInclusion(
								Object.fromEntries(
									connection.accounts.map((account) => [account.id, Boolean(get(fields, account.id))]),
								),
							)
						}
					}}
				/>
			</FormWrapper>
		</Wrapper>
	)
}
